import { render, staticRenderFns } from "./ContactRemark.vue?vue&type=template&id=385a4199"
import script from "./ContactRemark.vue?vue&type=script&lang=js"
export * from "./ContactRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports